// extracted by mini-css-extract-plugin
export default {"Content":"EmptyContentScreen_styles_Content__L8ZuN","IconContent":"EmptyContentScreen_styles_IconContent__kugkG","IconWrapper":"EmptyContentScreen_styles_IconWrapper__VWYkO"};